var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardListSection',_vm._b({staticClass:"c-frontpage-cards",class:'c-frontpage-cards--' + _vm.variant,attrs:{"id":("c-frontpage-cards-" + (_vm.$vnode.key)),"is-gray":false,"show-link-at-bottom":""}},'CardListSection',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }